import { i18n } from "@/i18n";

export default {
  path: "/profile/:id",
  name: "profile",
  component: () => import(/* webpackChunkName: "profile" */ "@/views/Account/ProfileView.vue"),
  meta: {
    authRequired: true,
    title: i18n.global.t("page.profile"),
    breadcrumb: true,
  },
};
